import { createAsyncThunk } from '@reduxjs/toolkit';

import { policyApi } from '../../services/policy';
import { AppThunkConfig } from '../../store';
import { hasProperty } from '../../utils/types';
import { updatePayMyBillPolicy } from '../analytics/trackAnalyticsSlice';
import { PayMyBillPolicy, updatePolicy, updatePolicyNotFound } from './slice';

export const retrievePolicyAction = createAsyncThunk<
  PayMyBillPolicy | null,
  string,
  AppThunkConfig
>('retrievePolicy', async (policyNumber, { dispatch }) => {
  const response = await dispatch(
    policyApi.endpoints?.getPolicy.initiate({ policyNumber })
  ).unwrap();
  if (hasProperty(response, 'error')) {
    if (response.error.type === 'NOT_FOUND') {
      dispatch(updatePolicyNotFound(true));
      return null;
    }
    throw new Error(`Unknown error ${response.error}`);
  } else {
    dispatch(updatePolicy(response));
    dispatch(updatePayMyBillPolicy(response));
  }
  return response;
});
